export default __webpack_public_path__ + "static/media/crates_commander_2.48178dcd.png";